import React, { useEffect, useState, useContext } from 'react';
import { Context } from 'Context/Context';
import { getAttConfirmedTeamUpsApi, removeInviteApi } from 'Constants';
import AreYouSureModal from 'Modals/AreYouSureModal';
import TeamUpDetailsModal from 'Modals/TeamUpDetailsModal';
import { PersonRow, TuPill, TU_ICON } from './TeamupUI';


function TeamupInvitesConfirmedAtt({ caseDetails, userInfo, setUpdateList, updateList, deleteTeamup, confirmedTeamUps }) {
    const { makeApiCallFunc } = useContext(Context);
    const [showPopUp, setShowPopUp] = useState(false);
    const [removeInviteId, setRemoveInviteId] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [detailsFunder, setDetailsFunder] = useState(null);
  return (
    <div
    >
        {
            showPopUp &&

            <AreYouSureModal text = "Are you sure you want to withdraw this teamup?"
            uploadNew={setShowPopUp}
            onClose={() => setShowPopUp(false)}
            onSubmit={() => { setShowPopUp(false); deleteTeamup(removeInviteId) }}
            buttonName='Delete Teamup'
            />

        }
        {
                showDetailsModal &&
                <TeamUpDetailsModal
                    onClose={() => setShowDetailsModal(false)}
                    uploadNew={showDetailsModal}
                    currentProf={detailsFunder}
                    showContact ={true}
                />
        }
      {
            confirmedTeamUps && confirmedTeamUps.length !== 0 &&
            confirmedTeamUps.map((invite) => (
                <PersonRow
                    key={invite._id}
                    user={invite?.toUser}
                    onDetails={() => { setShowDetailsModal(true); setDetailsFunder(invite?.toUser); }}
                    detailsLabel="Contact details"
                    extra={invite?.toUser?.email ?
                        <a href={`mailto:${invite?.toUser?.email}`} className="font-plexsans font-medium text-[12.5px] leading-[1.3] text-navy underline [overflow-wrap:anywhere]">{invite?.toUser?.email}</a> : null}
                    right={<TuPill tone="green" icon={TU_ICON.link}>Connected</TuPill>}
                />
            ))
        }
    </div>
  )
}

export default TeamupInvitesConfirmedAtt
